const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '自研视频加速引擎，首帧加载仅需0.8秒，拖动进度条秒开不等待，告别转圈焦虑。',
  },
  {
    icon: 'ri-translate',
    title: '智能字幕',
    desc: '支持中英双语字幕自动匹配，AI翻译准确率高，外语片也能轻松看懂。',
  },
  {
    icon: 'ri-cast-line',
    title: '一键投屏',
    desc: '支持DLNA/AirPlay多种投屏协议，手机内容无缝投射到电视大屏，全家共享观影乐趣。',
  },
  {
    icon: 'ri-moon-line',
    title: '夜间模式',
    desc: '深色主题护眼设计，低亮度环境下自动适配，长时间追剧不伤眼，观影更舒适。',
  },
  {
    icon: 'ri-shield-flash-line',
    title: '安全纯净',
    desc: '通过多家安全平台检测认证，无恶意代码、无隐私窃取，纯净安装包放心下载使用。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">核心优势</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">为什么千万用户选择91影视看片app？五大优势告诉你答案</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group text-center p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-secondary-200 transition-colors">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}